export class TobaccoModel {
    question: string;
    hideSmokerResponseMembers: boolean;
    fitInContainer: boolean;
    coveredMembers: TobaccoMembers;

    constructor(){
        this.question = null;
        this.hideSmokerResponseMembers = false;
        this.fitInContainer = false;
        this.coveredMembers = new TobaccoMembers();
    }
}

export class TobaccoMembers {
    totalItems: number;
    totalPages: number;
    pageSize: number;
    items: TobaccoItem[];

    constructor(){
        this.totalItems = 0;
        this.totalPages = 0;
        this.pageSize = 0;
        this.items = new Array<TobaccoItem>();
    }
}

export class TobaccoItem {
    systemNumber: number;
    coveredMemberName: string;
    relationship: string;
    isSmoker: boolean;

    constructor(){
        this.systemNumber = 0;
        this.coveredMemberName = null;
        this.relationship = null;
        this.isSmoker = false;
    }
}

export class TobaccoPayload {
    coveredMemberQuestions: TobaccoItem[];
    singleResponseIsSmoker: boolean;

    constructor(){
        this.coveredMemberQuestions = new Array<TobaccoItem>();
        this.singleResponseIsSmoker = false;
    }
}
